let mediaflkty = null;

function initMediaSlider() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const slider = document.querySelector('.pdp-above-fold-media');
    const staticWrapper = document.querySelector('.pdp-above-fold-static-image');

    if (!slider) return;

    slider.classList.remove('is-ready');

    // Destroy existing
    if (mediaflkty) {
        mediaflkty.destroy();
        mediaflkty = null;
    }

    // Remove old cloned slides
    slider.querySelectorAll('.from-static').forEach(el => el.remove());

    if (isMobile) {
        const staticImages = document.querySelectorAll('.pdp-above-fold-static-image-image-grid .fold-media-image');

        staticImages.forEach(img => {
            const clone = img.cloneNode(true);
            clone.classList.add('from-static');
            slider.appendChild(clone);
        });

        if (staticWrapper) staticWrapper.style.display = 'none';
    } else {
        if (staticWrapper) staticWrapper.style.display = '';
    }

    // ✅ Wait for images to load before Flickity
    const images = slider.querySelectorAll('img');
    let loaded = 0;

    images.forEach(img => {
        if (img.complete) {
            loaded++;
        } else {
            img.onload = () => {
                loaded++;
                if (loaded === images.length) initFlickity();
            };
        }
    });

    if (loaded === images.length) initFlickity();

    function initFlickity() {
        mediaflkty = new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            pageDots: true,
            prevNextButtons: true,
            draggable: true,
            adaptiveHeight: true
        });

        slider.classList.add('is-ready');
    }
}

// Init
initMediaSlider();

// Resize debounce
let resizeTimer;
window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initMediaSlider, 300);
});